import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ChargeSavedCard from "../../../api/chargeSavedCard";
import { deleteSaveCard } from "../../../api/deleteCard";
import { GetSavedCard } from "../../../api/getSavedCard";
import orderApi from "../../../api/OrderApi";
import {
  payment_type_card,
  payment_type_cash,
  payment_type_upi,
} from "../../../constant/constant";
import useAllCharges from "../../../hooks/AllCharge";
import { CLEARALLORDER } from "../../../redux/features/AllOrder";
import { CLEARCART } from "../../../redux/features/CartData";
import {
  CLEARCHECKOUTADDRESS,
  resetScheduleDeivery,
  setAddressModal,
} from "../../../redux/features/CheckoutAddress";
import { SETLOADER, SETPAYMENTOPTIONTYPE } from "../../../redux/features/common";
import {
  SETSELECTEDSTORE,
  setStoreCloseModal,
} from "../../../redux/features/store";
import {
  DELIVERY_STATUS,
  getCurrentTime,
  IsNullUndefine,
} from "../../../utils/helper";
import Konsole from "../../../utils/konsole/Konsole";
import ParseFloat from "../../../utils/ParseFloat";
import {
  RazorPayCreateOrderJson,
  saveOrderJson,
} from "../../../utils/payment/PaymentContant";
import GlobalButton from "../../Buttons/btn2/GlobalButton";
import { $confirmDialog } from "../../dialog/confirmDialog";
import Loader from "../../Loader/Loader";
import { ErrorToast } from "../../ToastComponent/ErrorToast";
import PaymentOptions from "./PaymentOptions";
import PaymentMethodSkeleton from "./PaymentOptionsSkelton";
import useStoreStatus from "../../../hooks/useStoreStatus";
import {
  RazorpayCreateOrder,
  RazorpayVerifyOrder,
} from "../../../api/razorPayApi";
import { SuccessToast } from "../../ToastComponent/SuccessToast";
import useAllApiCall from "../../../hooks/useAllApiCall";
const PaymentModal = React.lazy(() => import("../../Modal/PaymentModal"));
const NewPaymentWithRazorpay = () => {
  const { t } = useTranslation();
  // @@ hooks for check store open close
  const { returnIsStoreClose } = useStoreStatus();

  const fetchCardApiCall = useRef<any>(false);
  const storeDataApiCall = useRef<any>(false);
  const useAllChargesData = useAllCharges();
  const [
    taxes,
    discount,
    service_charge,
    remaining_amount,
    totalPrice,
    deliveryCharge,
  ] = useAllCharges();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const reduxStoreData = useSelector((state: any) => state);
  const { paymentOptionType } = reduxStoreData.commonData;
  const [isPaymentLoading, setIsPaymentLoading] = useState(false);
  const {
    store: { allStore },
  } = useSelector((state: any) => state);
  const {
    store: {
      selectedType,
      selectedStore: { stripe_connect, store_name, short_description },
    },
    userData: {
      user: { first_name, last_name, iso_code, phone, phone_code, email },
    },
    cartData: { items, itemCount, minOrderDeliveryPrice },
  } = reduxStoreData;
  const {
    checkoutAddress: { selectedAddress, deliveryInstruction, deliveryNotes },
    store: { savedPaymentCard },
  } = reduxStoreData;

  const handleOpenStoreCloseModal = () => {
    dispatch(setStoreCloseModal(true));
  };





  useEffect(() => {
    // @@ find the current store status
    if (storeDataApiCall?.current == false) {
      storeDataApiCall.current = true;
      dispatch(SETPAYMENTOPTIONTYPE(payment_type_upi))
  

    }
    return () => {
      fetchCardApiCall.current = false;
      storeDataApiCall.current = false;
    };
  }, []);

  // @@ click payment pay btn
  const handlePay = (val?: any) => {
    if(remaining_amount > 0 && minOrderDeliveryPrice > 0){
      navigate('/menu');
      return;
    }
    if (returnIsStoreClose) {
      handleOpenStoreCloseModal();
      return;
    }
    Konsole.log("getCurrentTime", getCurrentTime());
    if (selectedType == DELIVERY_STATUS) {
      // selected address
      if (Object.keys(selectedAddress)?.length == 0) {
        // ErrorToast("Please select delivery address");
        dispatch(setAddressModal(true));
        return;
      }

      Konsole.log("deliveryInstruction", deliveryInstruction);
    }

    if (IsNullUndefine(paymentOptionType)) {
      ErrorToast("Please select payment option.");
      return;
    }
    if (paymentOptionType == payment_type_cash) {
      handleCashPayment("cash");
      return;
    }

    // @@ payment
    handleCashPayment(paymentOptionType);
  };

  // @@ rajorpay payment

  // @@ order api
  const handleCashPayment = async (type: any, paymentIntent?: any) => {
    let paymentType = type ? type : payment_type_cash;
    // @@ for for order api json
    let is_saved_card = paymentIntent ? true : false;
    const _orderJson = saveOrderJson(
      reduxStoreData,
      useAllChargesData,
      paymentIntent ? paymentIntent : "",
      paymentType,
      is_saved_card
    );
    console.log('_orderJson', _orderJson)
    setIsPaymentLoading(true);
    const status = await orderApi(_orderJson);

    console.log("statusstatusstatus", status);
    sessionStorage.setItem("is_order_placed", "true");

    if (paymentType == payment_type_cash) {
      dispatch(SETLOADER(false));
      paymentSuccessAndRedirect(status, _orderJson);
    } else {
      razorPayInit(status.order_item_id, _orderJson);
    }
  };

  const razorPayInit = async (
    save_order_item_id: any,
    save_order_json: any
  ) => {
    try {
      const json_create_order = RazorPayCreateOrderJson(
        reduxStoreData,
        useAllChargesData,
        save_order_item_id
      );

      const orderRes = await RazorpayCreateOrder(json_create_order);

      if (orderRes.success) {
        const { amount, currency, order_id } = orderRes;

        const options: any = {
          key: process.env.REACT_APP_RAZORPAY_KEY,
          amount,
          currency,
          name: store_name,
          description: short_description?.slice(0, 254),
          order_id,
          handler: async function (response: any) {
            try {
              const verifyRes = await RazorpayVerifyOrder({
                ...response,
                order_id,
              });

              setIsPaymentLoading(false);
              if (verifyRes.success) {
                SuccessToast(verifyRes.message);
                paymentSuccessAndRedirect(save_order_item_id, save_order_json);
              } else {
                ErrorToast("Payment verification failed: " + verifyRes.message);
              }
            } catch (err) {
              console.error("Verify payment error", err);
              ErrorToast("Something went wrong during payment verification.");
            }
          },
          prefill: {
            name: `${first_name} ${last_name}`,
            email: email,
            contact: phone,
          },
          theme: { color: "#0D9488" },

          modal: {
            ondismiss: () => {
              setIsPaymentLoading(false);
              ErrorToast("Payment cancelled by user.");
            },
          },
          method: {
            // netbanking: false,
            // card: paymentOptionType == "card",
            // upi: paymentOptionType == "upi",
            // wallet: false,
            // emi: false,
          },
        };

        const razor = new (window as any).Razorpay(options);

        // 👇 Listen for payment failure
        razor.on("payment.failed", function (response: any) {
          setIsPaymentLoading(false);
          razor.close();
          ErrorToast("Payment failed: " + response.error.description);
          console.error("Razorpay payment failed", response.error);
        });

        razor.open();
      } else {
        setIsPaymentLoading(false);
        ErrorToast("Failed to create Razorpay order.");
      }
    } catch (err) {
      setIsPaymentLoading(false);
      console.error("Razorpay Init Error", err);
      ErrorToast("Something went wrong while initializing payment.");
    }
  };

  //   @@ payment and redirect
  const paymentSuccessAndRedirect = (order_id: any, json: any) => {
    setTimeout(() => {
      dispatch(CLEARCART());
      dispatch(CLEARALLORDER());
      dispatch(CLEARCHECKOUTADDRESS());
      dispatch(resetScheduleDeivery());
      sessionStorage.removeItem("items");
    }, 1000);
    navigate("/order-success", { state: { orderId: order_id, data: json } });
  };

  // @@ select payment option type
  const handlePaymentSelect = (type: any) => {
    // console.log("typePa+ymentoption", type);
    // setPaymentOptionType(type);
    dispatch(SETPAYMENTOPTIONTYPE(type))
  };
  // @@ list of payment options
  const paymentOptionsList = useMemo(() => {
    let list = [
      { label: "UPI | Card | Netbanking", value: payment_type_upi },
      // {
      //   label: "Card",
      //   label3: "2% extra charge will be applied.",
      //   value: payment_type_card,
      // },
    ];
    return list;
  }, []);

  // console.log("_paymentOptionsList", paymentOptionsList, paymentOptionType);
  return (
    <>
      <div className="paywith-mobile radio-saved-card md:p-5 p-4 pb-0 md:pb-0 bg-white md:rounded-[10px] md:mb-5 md:border-none border-t-2 border-b-2 border-[#E2E2E2]">
        <div className="flex justify-between  mb-4">
          <p className="text-xl font-splekta font-normal">
            {t("Checkout.payment_option")}
          </p>
        </div>
        <>
          <>
            {/* @@section display payment option */}
            <PaymentOptions
              optionsList={paymentOptionsList}
              selected_option={paymentOptionType}
              option_type="new"
              handlePaymentSelect={handlePaymentSelect}
            />
          </>
        </>
      </div>

      <Loader />

      <GlobalButton
        // disabled={remaining_amount > 0 && minOrderDeliveryPrice > 0}
        label={
          remaining_amount > 0 && minOrderDeliveryPrice > 0
            ? `Store minimum fee is ${ParseFloat(minOrderDeliveryPrice)}`
            : `Pay ${ParseFloat(totalPrice || 0)}`
        }
        label2={remaining_amount > 0 ? `Add ${ParseFloat(remaining_amount)} more ` : ''}

        onClick={() => handlePay()}
        loading={isPaymentLoading}
      />
    </>
  );
};

export default NewPaymentWithRazorpay;
